import React from 'react';
import style from './MapCluster.module.scss';
import PIEText from '@src/shared/components/PIEText';
import OrderMapMarkerIcon from '../MapMarkers/OrderMapMarker/OrderMapMarkerIcon';
import { Statuses } from '@src/pages/DeliveryDashboard/models/model-constants';
interface componentProps {
  onClick: () => void;
  childrenData: Array<any>;
}
const MapCluster = ({ onClick, childrenData }: componentProps) => {
  const sortByStatus = (data: Array<any>) => {
    return data.sort((a: any, b: any) => {
      if (a.properties.orderData.status === Statuses.Delivered) return 1;
      if (b.properties.orderData.status === Statuses.Delivered) return -1;
      return 0;
    });
  };

  const getChildrenDataSortedByStatus = () => {
    return sortByStatus(childrenData);
  };

  const retrieveOnlyStatuses = (data: Array<any>) => {
    return data.map((item) => item.properties.orderData.status);
  };

  const getDistinctStatuses = (data: Array<any>) => {
    return Array.from(new Set(data));
  };

  const getIdenticalStatuses = () => {
    const childrenData = getChildrenDataSortedByStatus();
    const allRetrievedStatuses = retrieveOnlyStatuses(childrenData);
    const distinctStatuses = getDistinctStatuses(allRetrievedStatuses);
    return new Array(childrenData.length >= 3 ? 3 : childrenData.length).fill(distinctStatuses[0]);
  };

  const getStatusesByMajority = () => {
    const childrenData = getChildrenDataSortedByStatus();
    const allRetrievedStatuses = retrieveOnlyStatuses(childrenData);
    const distinctStatuses = getDistinctStatuses(allRetrievedStatuses);
    const statusesSortedByMajority = distinctStatuses.sort((a: any, b: any) => {
      return (
        allRetrievedStatuses.filter((v) => v === b).length -
        allRetrievedStatuses.filter((v) => v === a).length
      );
    });
    if (statusesSortedByMajority[0] !== Statuses.Delivered) {
      return [...new Array(2).fill(statusesSortedByMajority[0]), statusesSortedByMajority[1]];
    } else {
      return [statusesSortedByMajority[1], ...new Array(2).fill(statusesSortedByMajority[0])];
    }
  };

  const getDiverseStatuses = () => {
    const childrenData = getChildrenDataSortedByStatus();
    const allRetrievedStatuses = retrieveOnlyStatuses(childrenData);
    const distinctStatuses = getDistinctStatuses(allRetrievedStatuses);
    return [...distinctStatuses];
  };

  const renderIcons = () => {
    const childrenDataSortedByStatus = getChildrenDataSortedByStatus();
    const allRetrievedStatuses = retrieveOnlyStatuses(childrenDataSortedByStatus);
    const distinctStatuses = getDistinctStatuses(allRetrievedStatuses);
    let computedStatuses = [];
    if (distinctStatuses.length === 1) {
      computedStatuses = getIdenticalStatuses();
    } else if (distinctStatuses.length === 2 && childrenDataSortedByStatus.length > 2) {
      computedStatuses = getStatusesByMajority();
    } else if (distinctStatuses.length === 2 && childrenDataSortedByStatus.length === 2) {
      computedStatuses = getDiverseStatuses();
    } else if (distinctStatuses.length === 3) {
      computedStatuses = getDiverseStatuses();
    }
    return computedStatuses.map((status, index) => (
      <div className={style.IconsHolder}>
        <OrderMapMarkerIcon key={index} orderStatus={status} />
      </div>
    ));
  };
  return (
    <div className={style.MapCluster} onClick={onClick}>
      <div className={style.MapClusterCountHolder}>
        <PIEText
          text={childrenData.length.toString()}
          color="var(--xds-color-content-bold)"
          size="var(--xds-font-size-16)"
          fontWeight="var(--xds-font-weight-bold)"
        />
      </div>
      {renderIcons()}
    </div>
  );
};

export default MapCluster;
